import {ECitiesId} from "@/searchSection/types/ECitiesId";

export enum ECities {
    MSK = 'msk',
    SPB = 'spb',
}

export const cityPathMap: Record<ECitiesId, ECities|string> = {
    [ECitiesId.MSK]: '',
    [ECitiesId.SPB]: ECities.SPB,
}